/**
 * Client-side alt fallback for hardcoded <img> tags and empty alt attributes.
 * Skips decorative images (data-alt-decorative on img or ancestor).
 */
(function () {
  'use strict';

  var config = window.__imageAltFallback || {};
  var baseTitle = (config.baseTitle || '').trim();

  function isDecorative(img) {
    if (img.getAttribute('data-alt-decorative') === 'true') return true;
    if (img.getAttribute('role') === 'presentation') return true;
    var parent = img.closest('[data-alt-decorative="true"]');
    return !!parent;
  }

  function needsAlt(img) {
    if (isDecorative(img)) return false;
    if (!img.hasAttribute('alt')) return true;
    var value = img.getAttribute('alt');
    return value === null || String(value).trim() === '';
  }

  function filenameFromSrc(src) {
    if (!src) return '';
    try {
      var pathname = new URL(src, window.location.origin).pathname;
      var segment = pathname.split('/').pop() || '';
      var name = segment.split('?')[0].split('.')[0];
      return name.replace(/[-_]+/g, ' ').replace(/\d{10,}/g, '').replace(/\s+/g, ' ').trim();
    } catch (e) {
      return '';
    }
  }

  function nearbyHeadingText(img) {
    var root = img.closest('section, article, .shopify-section, main, [role="main"]') || document.body;
    var heading = root.querySelector('h1, h2, h3');
    if (heading && heading.textContent) {
      return heading.textContent.trim();
    }
    return '';
  }

  function resolveBaseText(img) {
    var custom = img.getAttribute('data-alt-fallback');
    if (custom && custom.trim()) return custom.trim();

    custom = config.productTitle;
    if (custom && custom.trim() && document.body.classList.contains('template-product')) {
      return custom.trim();
    }

    var heading = nearbyHeadingText(img);
    if (heading) return heading;

    if (baseTitle) return baseTitle;

    var fromFile = filenameFromSrc(img.currentSrc || img.src || '');
    if (fromFile) return fromFile;

    return 'Image';
  }

  function applyFallback() {
    var images = Array.prototype.slice.call(document.querySelectorAll('img'));

    images.forEach(function (img) {
      if (isDecorative(img)) {
        if (!img.hasAttribute('alt')) {
          img.setAttribute('alt', '');
        }
        return;
      }
    });

    var targets = images.filter(needsAlt);
    var useIndex = targets.length > 1;

    targets.forEach(function (img, i) {
      var text = resolveBaseText(img);
      var index = i + 1;

      if (useIndex && index > 1) {
        img.setAttribute('alt', text + ' ' + index);
      } else {
        img.setAttribute('alt', text);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFallback);
  } else {
    applyFallback();
  }

  document.addEventListener('shopify:section:load', applyFallback);
})();
